import styled, { css } from 'styled-components';
import _Text from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/Text';
import _Title from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/Title';
import _Topic from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/Topic';
import _LearnablesLabel from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/LearnImmerseCommunicate/LearnablesLabel';
import theme from 'src/utils/theme';
import _YoutubeIframe from './YoutubeIframe';

export const FixFlexBasis = styled.div(
  () => css`
    width: 100%;

    > * {
      flex-basis: unset;
      margin-bottom: ${theme.sz.s6};
    }
  `,
);

export const LearnablesLabel = styled(_LearnablesLabel)(
  ({ theme }) => css`
    margin-bottom: ${theme.sz.s4};
  `,
);

export const Text = styled(_Text).attrs({
  $desktopStyles: css`
    margin-bottom: ${theme.sz.s6};
    font-size: ${theme.DEPRECATED_ty.medium};
    line-height: ${theme.DEPRECATED_ty.larger};
  `,
  $mobileStyles: css`
    margin-bottom: ${theme.sz.s6};
  `,
})(() => css``);

export const Title = styled(_Title).attrs({
  $desktopStyles: css`
    margin-bottom: ${theme.sz.s4};
  `,
  $mobileStyles: css`
    margin-bottom: ${theme.sz.s2};
  `,
})(() => css``);

export const Topic = styled(_Topic).attrs({
  $desktopStyles: css`
    margin-bottom: ${theme.sz.s4};
  `,
  $mobileStyles: css`
    margin-bottom: ${theme.sz.s2};
  `,
})(() => css``);

export const YoutubeIframe = styled(_YoutubeIframe)(
  () => css`
    width: 100%;
    margin-bottom: ${theme.sz.s6};
  `,
);
